export default __webpack_public_path__ + "static/media/success.21e2e03f.gif";